/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterContratos() {
        return axiosJwt
            .get(`${api}/comprometimentos/contratos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentos(filtroDto) {
        return axiosJwt
            .get(`${api}/comprometimentos?contrato=${filtroDto.contrato}&status=${filtroDto.status}&situacao=${filtroDto.situacao}&dataInicial=${filtroDto.dataInicial}&dataFinal=${filtroDto.dataFinal}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(idComprometimento) {
        let url = `${api}/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexosTipos() {
        let url = `${api}/comprometimentos/anexos/tipos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirComprometimentoAnexo(anexo) {
        const formData = new FormData()
        formData.append('idComprometimento', anexo.idComprometimento)
        formData.append('tipoId', anexo.tipoId)
        formData.append('descritivo', anexo.descritivo)
        formData.append('arquivo', anexo.arquivo)

        return axiosJwt
            .post(
                `${api}/comprometimentos/${anexo.idComprometimento}/anexos/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirComprometimentoAnexo(anexo) {
        let url = `${api}/comprometimentos/${anexo.idComprometimento}/anexos/excluir`
        return axiosJwt
            .post(url, anexo)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarComprometimentoParaAnalise(idComprometimento) {
        let url = `${api}/comprometimentos/${idComprometimento}/enviaranalise`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    cancelarEnvioComprometimentoParaAnalise(idComprometimento) {
        let url = `${api}/comprometimentos/${idComprometimento}/cancelarenvioanalise`
        return axiosJwt
            .patch(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(idComprometimento) {
        let url = `${api}/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadoresDisponiveis(idComprometimento) {
        let url = `${api}/comprometimentos/${idComprometimento}/aprovadores/disponiveis`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    designarComprometimentoAprovador(aprovador) {
        let url = `${api}/comprometimentos/${aprovador.idComprometimento}/aprovadores/designar`
        return axiosJwt
            .post(url, aprovador)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
